export const liveTracking = {
  activeVehicles: "在线设备",
  cameraBlocked: "摄像头遮挡",
  DSS: "驾驶行为",
  enter: "驶入",
  exit: "驶出",
  fatigue: "疲劳",
  fleet: "车间",
  fleetOrVehicleID: "车间或设备编号",
  front: "前方",
  geofencing: "电子围栏",
  left: "左方",
  location: "位置",
  model: "设备型号",
  NA: "未知",
  noData: "@:common.global.noData",
  nonActiveVehicles: "离线设备",
  PDCritical: "危险区人员侦测",
  phoneUsage: "使用手机",
  rear: "后方",
  refresh: "刷新",
  right: "右方",
  seatbelt: "未系安全带",
  smoking: "抽烟",
  speed: "速度",
  speeding: "超速",
  times: "0 次 | 1 次 | {val} 次",
  unassignedVehicles: "未分配的设备",
  unauthorizedDrivers: "未授权驾驶",
  unknownDriver: "@:common.global.unknownDriver",
  search4NoVehicleTips: "设备未注册。",
  realtimeVideo: "实时视频",
  offLineTime: "离线时间",
  noSignal: "无信号",
  SDCardError: "SD卡未识别",
  extDssSDCardError: "扩展SD卡未识别",
  hardHatOff: "未戴安全帽",
  cameraShift: "摄像头偏移",
  leaveSeat: "离开座位",
  deviceIsBusy: "系统繁忙，请稍后再试。",
  deviceUnResponse: "设备无应答，请稍后再试。",
  deviceIsOffline: "设备已下线。",
  videoFailure: "播放失败。",
  resourceFailure: "资源加载失败。",
  driverChanged: "司机换人",
  videoExceedQuota: "实时视频额度已用完。",
  frontRight: "右前方",
  rearRight: "右后方",
};
